/** Градиент по токенам темы — при вращении эффект «перелива» (как в админке). */
const LOADER_CONIC_BG =
  'conic-gradient(from 0deg, var(--accent), var(--focus-ring), var(--btn-primary-bg), color-mix(in srgb, var(--text-muted) 55%, var(--accent)), var(--accent))';

type Hole = 'elevated' | 'bg' | 'soft';

const HOLE_CLASS: Record<Hole, string> = {
  elevated: 'bg-[var(--bg-elevated)]',
  bg: 'bg-[var(--bg)]',
  soft: 'bg-[var(--bg-soft)]'
};

const RING_SIZE = {
  sm: 'h-8 w-8 p-[2px]',
  md: 'h-11 w-11 p-[3px]',
  lg: 'h-14 w-14 p-[4px]'
} as const;

type RingSize = keyof typeof RING_SIZE;

function cn(...parts: (string | false | undefined | null)[]): string {
  return parts.filter(Boolean).join(' ');
}

type LoaderRingProps = {
  size?: RingSize;
  hole?: Hole;
  className?: string;
};

export function LoaderRing({ size = 'md', hole = 'elevated', className }: LoaderRingProps) {
  return (
    <div
      className={cn('shrink-0 animate-spin rounded-full motion-reduce:animate-none', RING_SIZE[size], className)}
      style={{ background: LOADER_CONIC_BG }}
      role="presentation"
      aria-hidden
    >
      <div className={cn('h-full w-full rounded-full', HOLE_CLASS[hole])} />
    </div>
  );
}

type BlockLoaderProps = {
  className?: string;
  label?: string | null;
  size?: RingSize;
  hole?: Hole;
  minHeight?: boolean;
};

/** Прелоадер для блоков и стартового экрана виджета: кольцо + подпись (как в админке). */
export function BlockLoader({
  className,
  label = 'Загрузка…',
  size = 'md',
  hole = 'elevated',
  minHeight = true
}: BlockLoaderProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-4',
        minHeight ? 'min-h-[120px] py-8' : 'py-4',
        className
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <LoaderRing size={size} hole={hole} />
      {label != null && label !== '' ? (
        <p className="text-center text-sm text-[var(--text-muted)]">{label}</p>
      ) : null}
    </div>
  );
}
